import { RequestStatus } from 'clickNgo/configs/service/common'

import { IBasicInfoState } from './models/basicInfoState'
import { TBasicInfoDefault } from './models/partnerBasicInfo'

const initialBasicInfo: TBasicInfoDefault = {
  partnerId: '',
  programType: null,
  fYear: 0,

  branchesIsApplicable: false,
  branchesLocations: '',
  branchesCount: null,

  turnover: null,
  ppsShare: null,
  isMPSAuditRequirements: false,
  summary: '',
  achievement: '',

  // Retailer
  operationProfit: null,
  operationProfitYoY: null,
  ticker: '',
  growthStrategy: '',
  storesTotal: null,
  storesPSHW: null,
  storesPRHW: null,

  gtmOnlinePercentage: null,

  showroomsIsApplicable: false,
  showroomsLocations: '',
  showroomsCount: null,
  salesCount: null,
  serviceCount: null,
  demoUnits: null,

  warehouseIsApplicable: false,
  warehouseLocations: '',
  warehouseCount: null,
  totalSales: null,
  hpDedicatedSales: null,
  employersCount: null,
  exhibits: '',
  bridgeBaseline: null,
}

export const initialState: IBasicInfoState = {
  createdData: initialBasicInfo,
  defaultData: initialBasicInfo,
  status: RequestStatus.FULFILLED,
  message: '',
}
